import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITab } from 'src/app/shared/interfaces/ITab.interface';

@Component({
  standalone: false,
  selector: 'app-tab-navigation',
  templateUrl: './tab-navigation.component.html',
  styleUrls: ['./tab-navigation.component.scss'],
})
export class TabNavigationComponent {
  @Input() tabs: ITab[] = [];
  @Output() tabChange = new EventEmitter<string>();

  setActiveTab(tabId: string): void {
    this.tabs = this.tabs.map(tab => ({
      ...tab,
      isActive: tab.id === tabId,
    }));
    this.tabChange.emit(tabId);
  }
}
